"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function useClientNode() {
    var _a = react_1.useState(null), node = _a[0], setNode = _a[1];
    var ref = react_1.useCallback(function (e) {
        if (e !== null)
            setNode(e);
    }, []);
    return [node, ref];
}
exports.default = useClientNode;
//# sourceMappingURL=useClientNode.js.map